import { Roadmap } from "@/domain/common/roadmap";

export const isFetching = (state: any ) => {
    return state.isFetching
}

export const allRoadmaps = (state: any) => {
    return state.roadmaps
}